// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'zhf',
  messages: {
    'zhf': require('./VueI18n/language-zhf'),
    'cn': require('./VueI18n/language-cn'),
    'en': require('./VueI18n/language-en'),
    'tn': require('./VueI18n/language-tn'),
    'vn': require('./VueI18n/language-vn')
  },
  silentTranslationWarn: true,
})
Vue.config.productionTip = false
Vue.use(ElementUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js